import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { VersionPath } from 'app/core/common';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { EnabledPathsBookingsList } from '../../../services/api-services/bookingManager/models/path-booking-list';
import { BookingsRequest, BookingsResponse } from '../models/bookings.interface';

@Injectable({
  providedIn: 'root'
})
export class BookingListApiService {
  private readonly _http: HttpClient = inject(HttpClient);

  public loadBookingList(bookingRequest: BookingsRequest): Observable<BookingsResponse> {
    const url = `${environment.btbBFF.pbm.baseUrl}/${environment.btbBFF.pbm.nameApi}/${VersionPath.Version1}/${EnabledPathsBookingsList.Bookings}/${EnabledPathsBookingsList.GetByFilter}`;
    return this._http.post<BookingsResponse>(url, bookingRequest);
  }

  public loadBookingsListCreditShell(bookingRequest: BookingsRequest): Observable<BookingsResponse> {
    const url = `${environment.btbBFF.pbm.baseUrl}/${environment.btbBFF.pbm.nameApi}/${VersionPath.Version1}/${EnabledPathsBookingsList.Bookings}/${EnabledPathsBookingsList.GetFlightCreditByFilter}`;
    return this._http.post<BookingsResponse>(url, bookingRequest);
  }
}
